import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createBlock(_component_v_sheet, null, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3,
      _createVNode(_component_v_icon, {
        class: "mb-5",
        color: "success",
        icon: "mdi-check-circle",
        size: "112"
      }),
      _hoisted_4,
      _createVNode(_component_v_card_title, null, {
        default: _withCtx(() => [
          _createTextVNode("Успешная покупка")
        ]),
        _: 1
      }),
      _createVNode(_component_v_sheet, {
        width: "320px",
        class: "d-inline-flex flex-column justify-start"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_form, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createTextVNode(" Ваши билеты отправлены на почту ")
                ]),
                _: 1
              }),
              _createVNode(_component_v_btn, { onClick: _ctx.close }, {
                default: _withCtx(() => [
                  _createTextVNode(" OK ")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _hoisted_5,
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}